import { Pipe, PipeTransform } from '@angular/core';
import { LoginService } from '../../../../../../services/login/login.service';

@Pipe({
  name: 'tipoImpuesto'
})
export class TipoImpuestoPPipe implements PipeTransform {

  constructor(private login: LoginService) { }

  transform(value: string): string {
    if (this.login.isLogged()) {  // ya se encuentra logueado.
      if (this.login.getDataClientePedido().es_publicogeneral === 'SI') { // publico general 16% por default
        return '16%';
      }
      if (this.login.getDataClientePedido().es_publicogeneral === 'NO') {
        if (Number(this.login.getDataClientePedido().tipoImpuesto) === 0.08) {
          return '8%';
        }
        else if (Number(this.login.getDataClientePedido().tipoImpuesto) === 0.16) {
          return '16%';
        }
        else {
          return '16%';
        }
      }
    } else { // no se encuentra logueado.
      return '16%';
    }
  }

}
